export const EncabezadoTabla = ({ itemsEncabezado, ocultarEncabezadoMobile }) => {

    return (
        <>

            <div className={'row encabezadosTablas py-3 px-sm-3 px-0 bordeTablas align-items-center ' + (ocultarEncabezadoMobile ? 'ocultarMobile' : 'encMobile')}>
                {itemsEncabezado.map(function (elem) {
                    return (
                        <div className={elem.className}>{elem.text}</div>
                    )
                })}
            </div>
        </>
    );
}
